<h1 class="page-title">Táborok, konferenciák</h1>

<h2>Legfőbb céljuk</h2>

<p>
  Ezeken a rendezvényeken mindig van egy téma, amihez kapcsolódóan sok előadást, tanítást hallgatunk, amikből sokat
  tanulhatunk, nagyon gyakorlatias válaszokat, tippeket kapunk az élethez. De ez csak a hab a tortán, hiszen ilyenkor
  napokig, akár egy hétig is együtt vagyunk egész nap, így sok idő és lehetőség adódik arra, hogy új barátságok
  kötessenek, régiek mélyüljenek, sokat szórakozzunk együtt, mindezeket nyugodt környezetben, távol az otthon
  mindennapi, kimerítő teendőitől. Egy valóságos menyország egy héten át.
</p>

<h2>Nyári táboraink</h2>

<p>
  Már sok alkalommal rendeztük meg saját gyülekezetünk nyári táborát, igaz, az első egy-kettő inkább kirándulás volt, de
  nem voltak kevésbé jók. Minden évben egy csodát élünk át, egy csodában osztozunk mindazokkal, akik eljönnek ezekbe a
  táborokba. Az utóbbi években akkora lett az érdeklődés, hogy komolyan meg kellett fontolnunk annak a lehetőségét, hogy
  két tábort is szervezzünk. A legutóbbi táborunk Balatonbogláron volt.
</p>

<h2>Konferenciák</h2>

<p>
  Ezeket A Biblia Szól Egyház rendezi, minden évszakban egyet. Nagyon áldottak szoktak lenni, de milyenek is lennének,
  ha ennyi ember egy akarattal összejön, nagyszerű előadókat hallgatnak, sokat beszélgetnek, közösségben vannak
  egymással, és együtt imádják Istent.
</p>

<p>
  A tavaszi attól különleges, hogy egész Európából, sőt, az egész világból nagyon sokan eljönnek, a nyári pedig (igaz,
  ez inkább csak nekünk) attól, hogy Kaposváron van most már hosszú évek óta. Nagy áldás számunkra, hogy így sokan
  olyanok is részt tudnak rajta venni, akik nem engedhetnék meg maguknak, hogy elutazzanak messzebbre.
</p>



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/what-we-do/camps/camps.component.html